class FoxkitFlashSaleCountdown {
    constructor(t) {
        this.selectors = {
            countDown: ["[data-foxkit-countdown-timer]"],
            productForm: ".m-product-form"
        }, this.DAY_IN_MS = 864e5, this.HOUR_IN_MS = 36e5, this.storageKey = "__sf-prod-countdown-evergreen", this.ended = !1, this.productId = MinimogSettings.productId, this.settings = t, this.storageTimes = JSON.parse(localStorage.getItem(this.storageKey)) || {}, this.init()
    }
    ProductCountdownTimer(t) {
        const {
            locales: e = {},
            title: i
        } = t, {
            days: n = "days",
            hrs: o = "hrs",
            mins: s = "mins",
            secs: d = "secs"
        } = e;
        return `<div class="m-countdown-timer__header m:flex m:items-center">\n      <div class="m-countdown-timer__heading m:flex m:text-xl m:font-medium">${i}</div>\n    </div>\n    <div class="m-countdown-timer">\n      <div class="m-countdown-timer__wrapper">\n        <div class="m-countdown-timer__box m-countdown-timer__day">\n          <p class="countdown-timer-day m-countdown-timer__digit">00</p>\n          <p class="m-countdown-timer__text">${n}</p>\n        </div>\n        <div class="m-countdown-timer__separator">:</div>\n        <div class="m-countdown-timer__box m-countdown-timer__hour">\n          <p class="countdown-timer-hour m-countdown-timer__digit">00</p>\n          <p class="m-countdown-timer__text">${o}</p>\n        </div>\n        <div class="m-countdown-timer__separator">:</div>\n        <div class="m-countdown-timer__box m-countdown-timer__min">\n          <p class="countdown-timer-minute m-countdown-timer__digit">00</p>\n          <p class="m-countdown-timer__text">${s}</p>\n        </div>\n        <div class="m-countdown-timer__separator">:</div>\n        <div class="m-countdown-timer__box m-countdown-timer__sec">\n          <p class="countdown-timer-sec m-countdown-timer__digit">00</p>\n          <p class="m-countdown-timer__text">${d}</p>\n        </div>\n      </div>\n    </div>`
    }
    init = () => {
        this.domNodes = queryDomNodes(this.selectors), this.domNodes.countDown.forEach((t => {
            try {
                let e = !0,
                    i = !1;
                if (this.settings.schedule) {
                    const i = new Date(this.settings.schedule_time).getTime();
                    e = new Date(t.dataset.now).getTime() >= i
                }
                if ("true" === t.dataset.initialized || !e) return;
                const {
                    productId: n,
                    HOUR_IN_MS: o
                } = this, {
                    cdt_type: s = "fixed",
                    duration: d,
                    expires_date: r
                } = this.settings, m = Date.now();
                let c = new Date(r).getTime();
                if ("evergreen" === s) {
                    const t = this.getEvergreenTimeByProductId(n),
                        [e, s] = t.split("__").map(Number);
                    c = s, (c < m || e !== d) && (c = m + d * o), this.storageTimes[n] = [d, c].join("__"), this.saveTimesToStorage(), i = !0
                }
                if (c > m) {
                    const e = this.ProductCountdownTimer({
                            locales: t.dataset,
                            title: this.settings.title
                        }),
                        n = document.createElement("DIV");
                    n.classList.add("m-countdown-timer__container", `m-countdown-timer--${this.settings.cdt_style}`), n.innerHTML = e, t.appendChild(n), this.countDownTimer = new CountdownTimer(t, Date.now(), c, {
                        loop: i
                    }), t.classList.remove("m:hidden")
                } else this.ended = !0;
                t.dataset.initialized = "true"
            } catch (t) {}
        }))
    };
    getEvergreenTimeByProductId = t => this.storageTimes[t] || "";
    saveTimesToStorage = () => {
        localStorage.setItem(this.storageKey, JSON.stringify(this.storageTimes))
    }
}
MinimogTheme.FoxkitFlashSaleCountdown = FoxkitFlashSaleCountdown;